export default import.meta.ROLLDOWN_FILE_URL_YsAXz4$n1Qn9EsZBFmhgrA